import { populateImage } from './utils';

export default function (vm, options = {}) {
  const defaultContentType = '0';
  const recipes = options.data || [];

  return recipes.map(recipe => ({
    title: recipe.title,
    spot: recipe.spot,
    contentId: recipe.id.toString(),
    contentUrl: recipe.url,
    contentDate: recipe.publishDate,
    contentTypeId: defaultContentType,
    imageUrl: populateImage(recipe),
    isChiefSelection: recipe.isChiefSelection,
    mailingId: undefined,
    order: undefined,
  }));
}
